import { connect } from 'react-redux'
import Numbers from './Numbers'
import { get, flow } from 'lodash'
import { getNumbers } from 'features/Numbers/Numbers.actions'
import showNumbersNewServiceModal from 'features/Numbers/NumbersNewServiceModal'
import { reduxForm } from 'redux-form'
import { replace } from 'react-router-redux'
import { nonFlowServices } from 'features/Numbers/Numbers.utils'

const formName = 'numbersList'

const stateToProps = ({ numbers, form }, { location: { query } }) => {
  const formData = get(form, [formName, 'values'], {})
  const page = parseInt(query.page, 10) || 1
  return {
    page,
    services: nonFlowServices(numbers),
    servicesLoading: numbers.numbersLoading,
    formData,
  }
}

const dispatchToProps = {
  getNumbers,
  replace,
  showNumbersNewServiceModal,
}

export default flow(connect(stateToProps, dispatchToProps), reduxForm({ form: formName }))(Numbers)



// WEBPACK FOOTER //
// ./src/pages/Numbers/Numbers.container.js